import { FC } from "react";
import { IconPropsType } from ".";

export const Lock: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="3.5" width="11" height="10" rx="2.5" stroke={props.color} />
      <path
        d="M3.5 2C3.5 1.17157 4.17157 0.5 5 0.5H7C7.82843 0.5 8.5 1.17157 8.5 2V3.5H3.5V2Z"
        stroke={props.color}
      />
      <rect x="5.5" y="9.5" width="1" height="2" rx="0.5" stroke={props.color} />
    </svg>
  );
};
